import type { Announcement } from '../api/generated/Announcement'

/** `sam. 6 févr.` for a local day `YYYY-MM-DD`. */
export function formatDay(day: string): string {
  return new Date(`${day}T12:00:00Z`).toLocaleDateString('fr-FR', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  })
}

export function volunteers(count: number): string {
  return `${count} bénévole${count > 1 ? 's' : ''}`
}

/** Who an announcement went to, and for an organizer how many read it. */
export function describeAudience(
  announcement: Pick<Announcement, 'day' | 'recipients' | 'read'>,
): string {
  const audience = announcement.day
    ? `bénévoles du ${formatDay(announcement.day)}`
    : 'tous les bénévoles'
  if (announcement.recipients === null) return audience
  return `${audience} · lue par ${announcement.read ?? 0} sur ${announcement.recipients}`
}

/** Ids of `announcements` unread, added to those already `seen` unread, which stay highlighted once marked read. */
export function unreadIds(announcements: Announcement[], seen: ReadonlySet<string>): Set<string> {
  const ids = new Set(seen)
  for (const announcement of announcements) if (announcement.unread) ids.add(announcement.id)
  return ids
}
